import { tryList, toQueryString } from "./_shared";

export interface AuditLoginRow {
  id: string;
  created: string;
  email: string;
  success: boolean;
  ip_address: string | null;
  user_agent: string | null;
  failure_reason: string | null;
}

export interface AuditLoginFilters {
  dateRangeStart?: Date | string;
  success?: "true" | "false";
  email?: string;
  limit?: number;
}

export interface AuditPagePerformanceRow {
  id: string;
  created: string;
  path: string;
  full_page_load: number | null;
  ttfb: number | null;
  dns_time: number | null;
  tcp_time: number | null;
  download_time: number | null;
  dom_processing_time: number | null;
  resource_count: number | null;
  first_contentful_paint: number | null;
  largest_contentful_paint: number | null;
  total_blocking_time: number | null;
  total_transfer_size: number | null;
  total_resource_size: number | null;
  largest_resource_size: number | null;
  largest_resource_url: string | null;
}

export interface AuditPagePerformanceFilters {
  dateRangeStart?: Date | string;
  path?: string;
  slowOnly?: boolean;
  slowThresholdMs?: number;
  limit?: number;
}

function toIso(value: Date | string | undefined): string | undefined {
  if (value === undefined) return undefined;
  return value instanceof Date ? value.toISOString() : value;
}

export const auditLoginService = {
  list(filters: AuditLoginFilters = {}) {
    return tryList<AuditLoginRow>(
      `/api/audit/login${toQueryString({
        dateRangeStart: toIso(filters.dateRangeStart),
        success: filters.success,
        email: filters.email,
        limit: filters.limit,
      })}`,
    );
  },
};

export const pagePerformanceService = {
  list(filters: AuditPagePerformanceFilters = {}) {
    return tryList<AuditPagePerformanceRow>(
      `/api/audit/page-performance${toQueryString({
        dateRangeStart: toIso(filters.dateRangeStart),
        path: filters.path,
        slowOnly: filters.slowOnly ? "true" : undefined,
        slowThresholdMs: filters.slowThresholdMs,
        limit: filters.limit,
      })}`,
    );
  },
};
